// extracted by mini-css-extract-plugin
export var investorImage = "renderResource-module--investorImage--ff921";